import React, {useEffect, useRef} from "react";

export function Word({word, onWordClicked, highlight}) {
  const wordRef = useRef(null);
  useEffect(() => {
    if(highlight){
      wordRef.current.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
    }
  }, [highlight])
  return (
    <span
      ref={wordRef}
      className={`word noselect ${highlight ? 'word-selected' : ''}`}
      onDoubleClick={() => {
        onWordClicked(word)
      }}
      key={word.startTime + word.length + word.word}>{word.word} </span>)
}
